export default __webpack_public_path__ + "static/media/CoverBaby-2.991d7b75.png";